
import {
    consignorGroup,
    getAddUserBranch,
    getRole,
    getUserAccount,
    vehicleGroup,
    getFirmList,
    firmBranchAccountUserApi
} from "_services";
import {
    ButtonHeading,
    CommonInput,
    CustomSelect,
} from "components";
import { CityDropdownForTrip } from "components"; // Import lazy loading dropdown
import { addUser, editUser, getUserDetail } from "features";
import { errorSchema, utils } from "helper";
import useDocumentTitle from "hooks/useDocumentTitle";
import Loading from "pages/Loading";
import React, { useCallback, useEffect, useState, useRef } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import './addusernew.css'

const AddUserFirm = () => {
    useDocumentTitle("User | T360");
    const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;
    const firmUI = TRANSPORT_MODE !== "production" ? true : true

    const initial = {
        company_user_name: "",
        mobileno: "",
        email_id: "",
        role_id: "",
        branch_list: [],
        language: "eg",
        company_id: StorageService.getCompanyId(),
        consignor_group_id: "",
        vehicle_group_id: "",
        web_or_mobile: 0,
        trip_payment_approval: 0,
        expenses_approval: 0,
    };


    const mandatoryOptions = [
        { label: "Mandatory", value: 1 },
        { label: "Not Mandatory", value: 0 },
    ];

    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const disableFields = location?.state?.disableFields;
    const [formValue, setFormValue] = useState(initial);
    const [formError, setFormError] = useState("");

    // State for selected dropdown items
    const [consignorGroupDetails, setConsignorGroupDetails] = useState({});
    const [vehicleGroupDetails, setVehicleGroupDetails] = useState({});
    const [roleDetails, setRoleDetails] = useState({});
    const [branchList, setBranchList] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [userAccount, setUserAccount] = useState([]);
    const [modifyAccount, setModifyAccount] = useState([]);
    const [filterAccountList, setFilterAccountList] = useState([]);
    const companyIdRef = useRef(StorageService.getCompanyId());

    // 1. Add new state for firm management
    const [firmList, setFirmList] = useState([]);
    const [selectedFirmId, setSelectedFirmId] = useState(null);

    // 1. Add new state for firm management
    useEffect(() => {
        const initializeFirmData = async () => {
            if (!id) {
                if (firmUI) {
                    // Load firm data with branches and accounts
                    await loadFirmData();
                } else {
                    getUserAccountHandle();
                    getBranchList();
                }
            } else {
                await getUserDetaisHandle(id);
            }
        };

        initializeFirmData();
    }, [id]);

    useEffect(() => {
        let array = [];

        let newArray = userAccount?.map((item, index) => {
            array.push({
                ...item,
                category_id: item?.category_id,
                category_name: item?.sub_category_name,
                sub_category_name: item?.sub_category_name,
                sub_category_id: item?.sub_category_id,
                account_id: item?.account_id,
                account_name: item?.account_name,
                account_code: item?.code,
                selection:
                    item?.create &&
                        item?.view &&
                        item?.edit &&
                        item?.delete
                        ? 1
                        : 0,
                create: item?.create,
                view: item?.view,
                edit: item?.edit,
                delete: item?.delete,
            });
        });

        setModifyAccount(array);
    }, [userAccount]);


    // Fetch functions for lazy loading dropdowns
    const fetchConsignorGroup = useCallback(async (search, page, limit) => {
        try {
            const res = await consignorGroup({
                company_id: companyIdRef.current,
                limit,
                offset: page,
                search,
                status: 1,
            });

            if (res?.responseCode === 200) {
                const consignors = res.data.map((i) => ({
                    ...i,
                    label: i?.name,
                    value: i?._id,
                }));

                return {
                    items: consignors,
                    total: res.total_record || consignors.length,
                };
            }

            toast.error(res?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            console.error("Error fetching consignor groups:", error);
            return { items: [], total: 0 };
        }
    }, []);

    const fetchVehicleGroup = useCallback(async (search, page, limit) => {
        try {
            const res = await vehicleGroup({
                company_id: companyIdRef.current,
                limit,
                offset: page,
                search,
                status: 1,
            });

            if (res?.responseCode === 200) {
                const vehicles = res.data.vehicle_group_list?.map((i) => ({
                    ...i,
                    label: i?.name,
                    value: i?._id,
                }));

                return {
                    items: vehicles,
                    total: res.data.total_record || vehicles.length,
                };
            }

            toast.error(res?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            console.error("Error fetching vehicle groups:", error);
            return { items: [], total: 0 };
        }
    }, []);

    const fetchRole = useCallback(async (search, page, limit) => {
        try {
            const res = await getRole({
                company_id: companyIdRef.current,
            });

            if (res?.responseCode === 200) {
                const roles = res.data.roleDetail
                    ?.filter((i) => i?.role_name !== "Owner")
                    ?.filter((i) =>
                        search ? i.role_name.toLowerCase().includes(search.toLowerCase()) : true
                    )
                    .map((i) => ({
                        ...i,
                        label: i?.role_name,
                        value: i?._id,
                    }));

                // Pagination on filtered results
                const startIndex = (page - 1) * limit;
                const paginatedRoles = roles.slice(startIndex, startIndex + limit);

                return {
                    items: paginatedRoles,
                    total: roles.length,
                };
            }

            toast.error(res?.responseMessage);
            return { items: [], total: 0 };
        } catch (error) {
            console.error("Error fetching roles:", error);
            return { items: [], total: 0 };
        }
    }, []);

    const getBranchList = async () => {
        const res = await getAddUserBranch({
            company_id: StorageService.getCompanyId(),
        });

        if (res?.responseCode === 200) {
            setBranchList(res?.data?.branch_list);
        } else {
            toast.error(res?.responseMessage);
        }
    };

    const getUserAccountHandle = async () => {
        try {
            const resp = await getUserAccount({
                company_id: StorageService.getCompanyId(),
                category_id: 1,
            });

            if (resp?.responseCode === 200) {
                setUserAccount(resp?.data?.account_list);
            }
        } catch (error) {
            // throw error;
        }
    };

    const getFirmBranchAccountHandle = async () => {
        try {
            const resp = await firmBranchAccountUserApi({
                company_id: StorageService.getCompanyId(),
                // category_id: 1,
            });

            if (resp?.responseCode === 200) {
                setFirmList(resp?.data?.user?.firm_list);
            }
        } catch (error) {
            // throw error;
        }
    }

    // 3. Modified getUserDetaisHandle to handle both structures
    const getUserDetaisHandle = async (id) => {
        try {
            const resp = await getUserDetail({
                company_id: StorageService.getCompanyId(),
                param_user_id: id,
            });

            if (resp?.responseCode === 200) {
                setFormValue({
                    ...formValue,
                    company_user_name: resp?.data?.user?.company_user_name,
                    mobileno: resp?.data?.user?.user_id?.mobile_no,
                    email_id: resp?.data?.user?.email_id,
                    role_id: resp?.data?.user?.role_id?._id,
                    web_or_mobile: resp?.data?.user?.web_or_mobile,
                    consignor_group_id: resp?.data?.user?.consignor_group_id?._id,
                    vehicle_group_id: resp?.data?.user?.vehicle_group_id?._id,
                    expenses_approval: resp?.data?.user?.expenses_approval,
                    trip_payment_approval: resp?.data?.user?.trip_payment_approval
                });

                // Set dropdown selections
                if (resp?.data?.user?.consignor_group_id) {
                    setConsignorGroupDetails({
                        _id: resp?.data?.user?.consignor_group_id?._id,
                        name: resp?.data?.user?.consignor_group_id?.name,
                        label: resp?.data?.user?.consignor_group_id?.name,
                        value: resp?.data?.user?.consignor_group_id?._id,
                    });
                }

                if (resp?.data?.user?.vehicle_group_id) {
                    setVehicleGroupDetails({
                        _id: resp?.data?.user?.vehicle_group_id?._id,
                        name: resp?.data?.user?.vehicle_group_id?.name,
                        label: resp?.data?.user?.vehicle_group_id?.name,
                        value: resp?.data?.user?.vehicle_group_id?._id,
                    });
                }

                if (resp?.data?.user?.role_id) {
                    setRoleDetails({
                        _id: resp?.data?.user?.role_id?._id,
                        role_name: resp?.data?.user?.role_id?.role_name,
                        label: resp?.data?.user?.role_id?.role_name,
                        value: resp?.data?.user?.role_id?._id,
                    });
                }

                // Handle both payload structures
                if (firmUI && resp?.data?.user?.firm_list) {
                    setFirmList(resp.data.user.firm_list.map(firm => {
                        // Check if firm has any selected branches or accounts
                        const hasSelections =
                            firm.branch_list.some(b => b.selection === 1) ||
                            firm.account_list.some(a => a.view === 1);

                        return {
                            ...firm,
                            isExpanded: false,
                            isChecked: hasSelections  // Set based on existing selections
                        };
                    }));
                } else {
                    setBranchList(resp?.data?.user?.branch_list);
                    setUserAccount(resp?.data?.user?.account_list);
                }
            }
        } catch (error) {
            console.error("Error fetching user details:", error);
        }
    };


    const handleOnChange = async (name, value) => {
        const stateObj = {
            ...formValue,
            [name]:
                name === "role_id" ||
                    name === "consignor_group_id" ||
                    name === "vehicle_group_id"
                    ? value.value
                    : value,
        };

        setFormValue(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                stateObj,
                errorSchema.addUserSchema
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };


    // 5. Modified branch checkbox handler for firm support
    const handleCheckboxChange = (branchId) => {
        if (firmUI && selectedFirmId) {
            setFirmList(prevFirms =>
                prevFirms.map(firm =>
                    firm.firm_id === selectedFirmId
                        ? {
                            ...firm,
                            branch_list: firm.branch_list.map(branch =>
                                branch._id === branchId
                                    ? { ...branch, selection: branch.selection ? 0 : 1 }
                                    : branch
                            )
                        }
                        : firm
                )
            );
        } else {
            setBranchList(
                branchList.map((branch) =>
                    branch._id === branchId
                        ? { ...branch, selection: branch.selection ? 0 : 1 }
                        : branch
                )
            );
        }
    };

    const handleSelectAll = (event) => {
        const isChecked = event.target.checked;
        setBranchList(
            branchList.map((branch) => ({ ...branch, selection: isChecked ? 1 : 0 }))
        );
    };

    useEffect(() => {

        const filteredAccount = modifyAccount
            .filter((item) => item.view === 1)
            .map((item) => ({
                category_id: item?.category_id,
                sub_category_id: item?.sub_category_id,
                account_id: item?.account_id,
                selection: item?.selection,
                create: item?.create,
                view: item?.view,
                edit: item?.edit,
                delete: item?.delete,
                trip_payment_approval: item?.trip_payment_approval ? item?.trip_payment_approval : 0,
                expenses_approval: item?.expenses_approval ? item?.expenses_approval : 0
            }));

        setFilterAccountList(filteredAccount);
    }, [modifyAccount]);


    // 7. MOST IMPORTANT: Modified onSubmit to build correct payload
    const onSubmit = async (e, action) => {
        e.preventDefault();

        const validationResult = await utils.checkFormError(
            { ...formValue },
            errorSchema.addUserSchema
        );

        let payloadData;

        if (firmUI) {
            // NEW STRUCTURE: Build firm_list based payload
            const firmListData = firmList
                .map(firm => {
                    const selectedBranches = firm.branch_list
                        ?.filter(branch => branch.selection === 1)
                        .map(branch => branch._id) || [];

                    const filteredAccounts = firm.account_list
                        .filter(item => item.view === 1)
                        .map(item => ({
                            category_id: item?.category_id,
                            sub_category_id: item?.sub_category_id,
                            account_id: item?.account_id,
                            selection: item?.selection,
                            create: item?.create,
                            view: item?.view,
                            edit: item?.edit,
                            delete: item?.delete,
                            trip_payment_approval: item?.trip_payment_approval || 0,
                            expenses_approval: item?.expenses_approval || 0
                        }));

                    // if (selectedBranches.length === 0 && filteredAccounts.length === 0) {
                    //     return null;
                    // }

                    if (!firm?.isChecked) {
                        return null;
                    }
                    return {
                        firm_id: firm.firm_id,
                        branch_list: selectedBranches,
                        account_list: filteredAccounts
                    };
                }).filter(Boolean);;

            payloadData = {
                company_user_name: formValue?.company_user_name,
                mobileno: formValue?.mobileno,
                email_id: formValue?.email_id,
                role_id: formValue?.role_id,
                language: formValue?.language,
                company_id: formValue?.company_id,
                consignor_group_id: formValue?.consignor_group_id,
                vehicle_group_id: formValue?.vehicle_group_id,
                web_or_mobile: formValue?.web_or_mobile,
                firm_list: firmListData,
                trip_payment_approval: formValue?.trip_payment_approval,
                expenses_approval: formValue?.expenses_approval,
            };
        } else {
            // OLD STRUCTURE: Build direct branch_list and account_list payload
            const selectedBranches = branchList
                .filter(branch => branch.selection === 1)
                .map(branch => branch._id);

            const filteredAccounts = filterAccountList.length > 0
                ? filterAccountList
                : modifyAccount
                    .filter(item => item.view === 1)
                    .map(item => ({
                        category_id: item?.category_id,
                        sub_category_id: item?.sub_category_id,
                        account_id: item?.account_id,
                        selection: item?.selection,
                        create: item?.create,
                        view: item?.view,
                        edit: item?.edit,
                        delete: item?.delete,
                        trip_payment_approval: item?.trip_payment_approval || 0,
                        expenses_approval: item?.expenses_approval || 0
                    }));

            payloadData = {
                company_user_name: formValue?.company_user_name,
                mobileno: formValue?.mobileno,
                email_id: formValue?.email_id,
                role_id: formValue?.role_id,
                branch_list: selectedBranches,
                language: formValue?.language,
                company_id: formValue?.company_id,
                consignor_group_id: formValue?.consignor_group_id,
                vehicle_group_id: formValue?.vehicle_group_id,
                web_or_mobile: formValue?.web_or_mobile,
                account_list: filteredAccounts,
                trip_payment_approval: formValue?.trip_payment_approval,
                expenses_approval: formValue?.expenses_approval,
            };
        }

        if (validationResult === true) {
            try {
                setDisabled(true);
                const res = await dispatch(
                    !id
                        ? addUser(payloadData)
                        : editUser({ ...payloadData, param_user_id: id })
                );

                if (res?.payload?.responseCode === 200) {
                    toast.success(res?.payload?.responseMessage);
                    if (action === "add") {
                        navigate("/setting/user");
                        setDisabled(false);
                        clearAll();
                    } else {
                        clearAll();
                        setDisabled(false);
                    }
                } else {
                    setDisabled(false);
                }
            } catch (error) {
                setDisabled(false);
            }
        } else {
            setFormError(validationResult);
        }
    };

    const handleFirmSelect = (firmId) => {
        setSelectedFirmId(firmId);
    };



    const handleCheckboxChangeForAccount = (subCategoryId, accountId, field, value) => {
        if (firmUI && selectedFirmId) {
            setFirmList(prevFirms =>
                prevFirms.map(firm =>
                    firm.firm_id === selectedFirmId
                        ? {
                            ...firm,
                            account_list: firm.account_list.map(account => {
                                if (
                                    account.sub_category_id === subCategoryId &&
                                    account.account_id === accountId
                                ) {
                                    let updatedAccount = { ...account, [field]: value };

                                    // Apply your existing logic
                                    if (
                                        (updatedAccount.create === 1 ||
                                            updatedAccount.edit === 1 ||
                                            updatedAccount.delete === 1) &&
                                        field !== "view"
                                    ) {
                                        updatedAccount.view = 1;
                                    } else if (field === "view") {
                                        updatedAccount.view = value;
                                    }

                                    if (["view", "create", "edit", "delete"].includes(field) && !value) {
                                        updatedAccount.selection = 0;
                                    }

                                    if (field === "selection") {
                                        updatedAccount = {
                                            ...updatedAccount,
                                            view: value,
                                            create: value,
                                            edit: value,
                                            delete: value,
                                        };
                                    }

                                    if (
                                        updatedAccount.view === 1 &&
                                        updatedAccount.create === 1 &&
                                        updatedAccount.edit === 1 &&
                                        updatedAccount.delete === 1
                                    ) {
                                        updatedAccount.selection = 1;
                                    }

                                    return updatedAccount;
                                }
                                return account;
                            })
                        }
                        : firm
                )
            );
        } else {
            // Use existing logic for non-firm mode
            setModifyAccount((prevData) =>
                prevData.map((account) => {
                    if (
                        account.sub_category_id === subCategoryId &&
                        account.account_id === accountId
                    ) {
                        let updatedAccount = { ...account, [field]: value };

                        if (
                            (updatedAccount.create === 1 ||
                                updatedAccount.edit === 1 ||
                                updatedAccount.delete === 1) &&
                            field !== "view"
                        ) {
                            updatedAccount.view = 1;
                        } else {
                            updatedAccount.view = 0;
                        }

                        if (field === "view") {
                            updatedAccount.view = value;
                        }

                        if (["view", "create", "edit", "delete"].includes(field) && !value) {
                            updatedAccount.selection = 0;
                        }

                        if (field === "selection") {
                            updatedAccount = {
                                ...updatedAccount,
                                view: value,
                                create: value,
                                edit: value,
                                delete: value,
                            };
                        }

                        if (
                            updatedAccount.view === 1 &&
                            updatedAccount.create === 1 &&
                            updatedAccount.edit === 1 &&
                            updatedAccount.delete === 1
                        ) {
                            updatedAccount.selection = 1;
                        }

                        return updatedAccount;
                    }
                    return account;
                })
            );
        }
    };


    const handleAccountAccessToggle = (e) => {
        const isChecked = e.target.checked;
        setModifyAccount((prevData) =>
            prevData.map((account) => ({
                ...account,
                selection: isChecked ? 1 : 0,
                view: isChecked ? 1 : 0,
                create: isChecked ? 1 : 0,
                edit: isChecked ? 1 : 0,
                delete: isChecked ? 1 : 0,
            }))
        );
    };

    const isAllChecked = modifyAccount.every(
        (account) => account.selection === 1

    );

    const handleApprovalChange = (subCategoryId, accountId, field, value) => {

        setModifyAccount((prevAccounts) =>
            prevAccounts.map((account) => {

                if (
                    account.sub_category_id === subCategoryId &&
                    account.account_id === accountId
                ) {
                    const updatedAccount = { ...account, [field]: value };
                    return updatedAccount;
                }

                return account;
            })
        );
    };

    const handleFirmCheckboxChange = useCallback((firmId) => {
        setFirmList(prevFirms =>
            prevFirms.map(firm => {
                if (firm.firm_id?._id === firmId) {
                    const newCheckedState = !firm.isChecked;

                    if (!newCheckedState) {
                        return {
                            ...firm,
                            isChecked: false,
                            branch_list: firm?.branch_list?.map(branch => ({
                                ...branch,
                                selection: 0
                            })),
                            account_list: firm?.account_list?.map(account => ({
                                ...account,
                                selection: 0,
                                view: 0,
                                create: 0,
                                edit: 0,
                                delete: 0,
                                trip_payment_approval: 0,
                                expenses_approval: 0
                            }))
                        };
                    }

                    return {
                        ...firm,
                        isChecked: true
                    };
                }
                return firm;
            })
        );
    }, []); // No dependencies needed as it uses functional updates

    // 2. Handle select all branches for a specific firm
    const handleSelectAllBranchesForFirm = (firmId) => {
        setFirmList(prevFirms =>
            prevFirms.map(firm => {
                if (firm?.firm_id?._id === firmId) {
                    const allSelected = firm?.branch_list?.every(b => b?.selection === 1);
                    return {
                        ...firm,
                        branch_list: firm?.branch_list?.map(branch => ({
                            ...branch,
                            selection: allSelected ? 0 : 1
                        }))
                    };
                }
                return firm;
            })
        );
    };
    // 3. Handle individual branch checkbox for a firm
    const handleBranchCheckboxForFirm = (firmId, branchId) => {
        setFirmList(prevFirms =>
            prevFirms?.map(firm => {
                if (firm?.firm_id?._id === firmId) {
                    return {
                        ...firm,
                        branch_list: firm?.branch_list?.map(branch =>
                            branch?._id === branchId
                                ? { ...branch, selection: branch?.selection ? 0 : 1 }
                                : branch
                        )
                    };
                }
                return firm;
            })
        );
    };

    // 4. Handle account access toggle for a firm (all accounts)
    const handleAccountAccessToggleForFirm = (firmId) => {
        setFirmList(prevFirms =>
            prevFirms?.map(firm => {
                if (firm?.firm_id?._id === firmId) {
                    const allSelected = firm?.account_list?.every(a => a?.selection === 1);
                    return {
                        ...firm,
                        account_list: firm?.account_list?.map(account => ({
                            ...account,
                            selection: allSelected ? 0 : 1,
                            view: allSelected ? 0 : 1,
                            create: allSelected ? 0 : 1,
                            edit: allSelected ? 0 : 1,
                            delete: allSelected ? 0 : 1,
                        }))
                    };
                }
                return firm;
            })
        );
    };

    // 5. Handle individual account checkbox for a firm
    const handleAccountCheckboxForFirm = (firmId, subCategoryId, accountId, field, value) => {
        setFirmList(prevFirms =>
            prevFirms.map(firm => {
                if (firm.firm_id?._id === firmId) {
                    return {
                        ...firm,
                        account_list: firm.account_list.map(account => {
                            if (
                                account.sub_category_id === subCategoryId &&
                                account.account_id === accountId
                            ) {
                                let updatedAccount = { ...account, [field]: value };

                                // Apply permission logic
                                if (
                                    (updatedAccount.create === 1 ||
                                        updatedAccount.edit === 1 ||
                                        updatedAccount.delete === 1) &&
                                    field !== "view"
                                ) {
                                    updatedAccount.view = 1;
                                } else if (field === "view") {
                                    updatedAccount.view = value;
                                }

                                if (["view", "create", "edit", "delete"].includes(field) && !value) {
                                    updatedAccount.selection = 0;
                                }

                                if (field === "selection") {
                                    updatedAccount = {
                                        ...updatedAccount,
                                        view: value,
                                        create: value,
                                        edit: value,
                                        delete: value,
                                    };
                                }

                                if (
                                    updatedAccount.view === 1 &&
                                    updatedAccount.create === 1 &&
                                    updatedAccount.edit === 1 &&
                                    updatedAccount.delete === 1
                                ) {
                                    updatedAccount.selection = 1;
                                }

                                return updatedAccount;
                            }
                            return account;
                        })
                    };
                }
                return firm;
            })
        );
    };

    // 6. Handle approval changes (Trip/Expenses) for firm accounts
    const handleApprovalChangeForFirm = (firmId, subCategoryId, accountId, field, value) => {
        setFirmList(prevFirms =>
            prevFirms.map(firm => {
                if (firm.firm_id?._id === firmId) {
                    return {
                        ...firm,
                        account_list: firm.account_list.map(account => {
                            if (
                                account.sub_category_id === subCategoryId &&
                                account.account_id === accountId
                            ) {
                                return { ...account, [field]: value };
                            }
                            return account;
                        })
                    };
                }
                return firm;
            })
        );
    };
    // 7. Updated isFormValid function
    const isFormValid = () => {
        const basicValidation =
            formValue?.company_id &&
            formValue?.company_user_name &&
            formValue?.role_id &&
            formValue?.mobileno;

        if (!basicValidation) return false;

        if (firmUI) {
            // Only check firms that are checked or have selections
            return firmList.some(firm => {
                const isCheckedOrHasSelections = firm.isChecked ||
                    firm.branch_list.some(b => b.selection === 1) ||
                    firm.account_list.some(a => a.view === 1);

                if (!isCheckedOrHasSelections) return false;

                const hasSelectedBranches = firm.branch_list.some(b => b.selection === 1);
                const hasViewAccounts = firm.account_list.some(a => a.view === 1);
                return hasSelectedBranches && hasViewAccounts;
            });
        } else {
            const selectedBranches = branchList.filter(b => b.selection === 1);
            const hasAccounts = filterAccountList.length > 0 ||
                modifyAccount.some(a => a.view === 1);
            return selectedBranches.length > 0 && hasAccounts;
        }
    };
    // 8. Initialize firm data with accounts
    const initializeFirmWithAccounts = async (firmId) => {
        try {
            const resp = await getUserAccount({
                company_id: StorageService.getCompanyId(),
                category_id: 1,
                firm_id: firmId // if your API supports firm-specific accounts
            });

            if (resp?.responseCode === 200) {
                const accountsWithDefaults = resp?.data?.account_list.map(item => ({
                    ...item,
                    category_id: item?.category_id,
                    category_name: item?.sub_category_name,
                    sub_category_name: item?.sub_category_name,
                    sub_category_id: item?.sub_category_id,
                    account_id: item?.account_id,
                    account_name: item?.account_name,
                    account_code: item?.code,
                    selection: 0,
                    create: 0,
                    view: 0,
                    edit: 0,
                    delete: 0,
                    trip_payment_approval: 0,
                    expenses_approval: 0
                }));

                return accountsWithDefaults;
            }
            return [];
        } catch (error) {
            console.error("Error initializing firm accounts:", error);
            return [];
        }
    };


    // 9. Load firm data on mount or when needed
    const loadFirmData = async () => {
        if (firmUI && !id) {
            getFirmBranchAccountHandle()
        }
    };

    // 10. Update clearAll function to handle firms
    const clearAll = () => {
        setFormValue(initial);
        setConsignorGroupDetails({});
        setVehicleGroupDetails({});
        setRoleDetails({});

        if (firmUI) {
            setFirmList(prevFirms =>
                prevFirms.map(firm => ({
                    ...firm,
                    isChecked: false,      // ADD THIS
                    isExpanded: false,     // ADD THIS
                    branch_list: firm.branch_list.map(branch => ({
                        ...branch,
                        selection: 0
                    })),
                    account_list: firm.account_list.map(account => ({
                        ...account,
                        selection: 0,
                        view: 0,
                        create: 0,
                        edit: 0,
                        delete: 0,
                        trip_payment_approval: 0,
                        expenses_approval: 0
                    }))
                }))
            );
        } else {
            // Clear old structure
            modifyAccount?.forEach((item, index) => {
                let newData = [...modifyAccount];
                newData[index].isSelected = 0;
                newData[index].selection = 0;
                newData[index].view = 0;
                newData[index].create = 0;
                newData[index].edit = 0;
                newData[index].delete = 0;
                newData[index].trip_payment_approval = 0;
                newData[index].expenses_approval = 0;
                setModifyAccount(newData);
            });

            setBranchList(branchList.map(branch => ({ ...branch, selection: 0 })));
        }
    };
    return (
        <div className="__profilCmp_main setting-nw-parentBx">
            <ButtonHeading
                title={
                    disableFields === true ? "View User" : id ? "Edit User" : "Add User"
                }
                className="commonHeading_title"
                buttonTitle={"Add User"}
                backButtonTitle={disableFields === true && 'Back'}
                backButtonClickHandler={() => disableFields === true && navigate(-1)}
            />

            {(firmUI ? firmList?.length > 0 : branchList?.length > 0) ? (
                <>
                    <div className="_addContainer">
                        <div className="_allUrs_bx">
                            <div className="_addRl_bx">
                                <div className="_addRlHead">User Details</div>

                                <div className="_addRl_tableBx">
                                    <div className="_usrDetails">
                                        <div className="pr_procssBx_grid">
                                            <div className="_tierDivs">
                                                <CommonInput
                                                    type="text"
                                                    placeholder="User Name*"
                                                    label="User Name*"
                                                    name="company_user_name"
                                                    disabled={disableFields}
                                                    value={formValue?.company_user_name || ""}
                                                    focus={!!formError?.company_user_name}
                                                    error={formError?.company_user_name}
                                                    onChange={({ target: { name, value } }) =>
                                                        handleOnChange(name, value)
                                                    }
                                                />
                                            </div>

                                            <div className="_tierDivs">
                                                <CommonInput
                                                    type="text"
                                                    placeholder="Mobile Number*"
                                                    label="Mobile Number*"
                                                    name="mobileno"
                                                    maxLength="16"
                                                    disabled={id || disableFields}
                                                    value={formValue?.mobileno || ""}
                                                    focus={!!formError?.mobileno}
                                                    error={formError.mobileno}
                                                    onChange={({ target: { name, value } }) => {
                                                        let cleanedValue = value.replace(/\D/g, '');
                                                        if (cleanedValue.startsWith('91') && cleanedValue.length > 10) {
                                                            cleanedValue = cleanedValue.substring(2);
                                                        }
                                                        if (/^\d{0,10}$/.test(cleanedValue)) {
                                                            handleOnChange(name, cleanedValue);
                                                        }
                                                    }}
                                                />
                                            </div>

                                            <div className="_tierDivs">
                                                <CommonInput
                                                    type="text"
                                                    placeholder="Email ID"
                                                    label="Email ID"
                                                    name="email_id"
                                                    disabled={disableFields}
                                                    value={formValue?.email_id || ""}
                                                    focus={!!formError?.email_id}
                                                    error={formError.email_id}
                                                    onChange={({ target: { name, value } }) =>
                                                        handleOnChange(name, value)
                                                    }
                                                />
                                            </div>

                                            <div className="_tierDivs">
                                                <CityDropdownForTrip
                                                    label="Role"
                                                    placeholder="Select a Role"
                                                    fetchData={fetchRole}
                                                    pageSize={20}
                                                    onChange={(data) => {
                                                        handleOnChange("role_id", data);
                                                        setRoleDetails(data);
                                                    }}
                                                    selectedItem={roleDetails}
                                                    disabled={disableFields}
                                                    error={formError.role_id}
                                                />
                                            </div>

                                            <div className="_tierDivs">
                                                <CityDropdownForTrip
                                                    label="Consignor Group"
                                                    placeholder="Select Consignor Group"
                                                    fetchData={fetchConsignorGroup}
                                                    pageSize={20}
                                                    onChange={(data) => {
                                                        handleOnChange("consignor_group_id", data);
                                                        setConsignorGroupDetails(data);
                                                    }}
                                                    selectedItem={consignorGroupDetails}
                                                    disabled={disableFields}
                                                    error={formError.consignor_group_id}
                                                    errorMessage={formError.consignor_group_id}
                                                />
                                            </div>

                                            <div className="_tierDivs">
                                                <CityDropdownForTrip
                                                    label="Vehicle Group"
                                                    placeholder="Select Vehicle Group"
                                                    fetchData={fetchVehicleGroup}
                                                    pageSize={20}
                                                    onChange={(data) => {
                                                        handleOnChange("vehicle_group_id", data);
                                                        setVehicleGroupDetails(data);
                                                    }}
                                                    selectedItem={vehicleGroupDetails}
                                                    disabled={disableFields}
                                                    error={formError.vehicle_group_id}
                                                    errorMessage={formError.vehicle_group_id}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="checkBx_lv ">
                                        <input
                                            className="form-check-input _avPointer"
                                            id="0pay_type1"
                                            type="radio"
                                            name="web_or_mobile"
                                            value={0}
                                            disabled={disableFields}
                                            checked={formValue?.web_or_mobile == 0}
                                            autoComplete="off"
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                        <label htmlFor="0pay_type1" className="form-check-label _avPointer">
                                            All
                                        </label>
                                        &nbsp;
                                        <input
                                            className="form-check-input _avPointer"
                                            id="1pay_type2"
                                            type="radio"
                                            name="web_or_mobile"
                                            value={1}
                                            disabled={disableFields}
                                            checked={formValue?.web_or_mobile == 1}
                                            autoComplete="off"
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                        <label htmlFor="1pay_type2" className="form-check-label _avPointer">
                                            Web Access
                                        </label>
                                        &nbsp;
                                        <input
                                            className="form-check-input _avPointer"
                                            id="1pay_type3"
                                            type="radio"
                                            name="web_or_mobile"
                                            value={2}
                                            disabled={disableFields}
                                            checked={formValue?.web_or_mobile == 2}
                                            autoComplete="off"
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                        <label htmlFor="1pay_type3" className="form-check-label _avPointer">
                                            Mobile Access
                                        </label>
                                        &nbsp;
                                    </div>
                                </div>
                            </div>

                            {/* MAIN CONDITIONAL RENDERING: Firm-based vs Direct structure */}
                            <div className="_mainRl_table __adUsr_AccTable">
                                {firmUI ? (
                                    // NEW STRUCTURE: Firm-based accordion
                                    <div className="accordion" id="accordionFirmList">
                                        {firmList.map((firm, firmIndex) => {

                                            const currentFirmBranches = firm.branch_list || [];
                                            const currentFirmAccounts = firm.account_list || [];
                                            const isAllBranchesSelected =
                                                currentFirmBranches.length > 0 &&
                                                currentFirmBranches.every(branch => branch.selection === 1);

                                            const isAllAccountsSelected =
                                                currentFirmAccounts.length > 0 &&
                                                currentFirmAccounts.every(account => account?.selection === 1);

                                            const isAnyBranchSelected =
                                                currentFirmBranches.length > 0 &&
                                                currentFirmBranches.some(branch => branch.selection === 1);

                                            const isAnyAccountSelected =
                                                currentFirmAccounts.length > 0 &&
                                                currentFirmAccounts.some(account => account?.selection === 1);



                                            return (
                                                <div className="accordion-item" key={firm?.firm_id?._id}>
                                                    <h2 className="accordion-header" id={`heading${firmIndex}`}>
                                                        <button
                                                            className={`accordion-button ${!firm?.isChecked ? 'collapsed' : ''}`}
                                                            type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target={`#collapse${firmIndex}`}
                                                            aria-expanded={firm?.isChecked}
                                                            aria-controls={`collapse${firmIndex}`}
                                                            onClick={() => {
                                                                // ❌ checkbox logic hata diya
                                                                handleFirmSelect(firm?.firm_id?._id); // optional: only select
                                                            }}
                                                        >
                                                            <div className="_addRl_headCheck">
                                                                <Checkbox
                                                                    type="checkbox"
                                                                    name={`${firm?.firm_id?.firm} (Firm)` || `Firm ${firmIndex + 1}`}
                                                                    id={`firm_${firm?.firm_id?._id}`}
                                                                    className='__addRhCheck'
                                                                    isDisabled={disableFields}
                                                                    isChecked={firm?.isChecked || isAnyBranchSelected || isAnyAccountSelected}
                                                                    handleClick={(e) => {
                                                                        e.stopPropagation();   // ✅ accordion trigger stop
                                                                        handleFirmCheckboxChange(firm?.firm_id?._id);
                                                                    }}
                                                                />
                                                            </div>
                                                        </button>
                                                    </h2>

                                                    <div
                                                        id={`collapse${firmIndex}`}
                                                        className={`accordion-collapse collapse ${firm?.isChecked ? 'show' : ''}`}
                                                        aria-labelledby={`heading${firmIndex}`}
                                                        data-bs-parent="#accordionFirmList"
                                                    >
                                                        <div className="__adUsr_accordBx">
                                                            {/* Branch Selection */}
                                                            {currentFirmBranches?.length > 1 && <Checkbox
                                                                type="checkbox"
                                                                name="All Branch"
                                                                className='__checkAllBox'
                                                                id={`selectAllBranch_${firm?.firm_id?._id}`}
                                                                isDisabled={disableFields}
                                                                handleClick={() => handleSelectAllBranchesForFirm(firm?.firm_id?._id)}
                                                                isChecked={isAllBranchesSelected}
                                                            />}

                                                            <div className="_addRl_checkList">
                                                                <div className="_brxFlex">
                                                                    {currentFirmBranches.map((branch, branchIndex) => (
                                                                        <div className="_dLass" key={`${branch._id}_${branchIndex}`}>
                                                                            <Checkbox
                                                                                className="checkbox_2"
                                                                                index={branchIndex}
                                                                                type="checkbox"
                                                                                name={branch?.branch}
                                                                                isDisabled={disableFields}
                                                                                id={`${firm?.firm_id?._id}_${branch._id}`}
                                                                                handleClick={() => handleBranchCheckboxForFirm(firm?.firm_id?._id, branch._id)}
                                                                                isChecked={branch?.selection === 1}
                                                                            />
                                                                        </div>
                                                                    ))}
                                                                </div>

                                                                {/* Account Access Table */}
                                                                {currentFirmAccounts?.length > 0 && <div className="_mainRl_table __nWd_table">
                                                                    <div className="_addRl_headCheck">
                                                                        <input
                                                                            id={`accountAccess_${firm?.firm_id?._id}`}
                                                                            type="checkbox"
                                                                            onChange={() => handleAccountAccessToggleForFirm(firm?.firm_id?._id)}
                                                                            checked={isAllAccountsSelected}
                                                                            disabled={disableFields}
                                                                        />
                                                                        <label htmlFor={`accountAccess_${firm?.firm_id?._id}`} className="anvLabel">
                                                                            <p className="anvLabel">Account Access</p>
                                                                        </label>
                                                                    </div>

                                                                    <table>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Accounts</th>
                                                                                <th>Full Access</th>
                                                                                <th>View</th>
                                                                                <th>Create</th>
                                                                                <th>Edit</th>
                                                                                <th>Delete</th>
                                                                                <th>Trip Approval</th>
                                                                                <th>Expenses Approval</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {currentFirmAccounts.map((account) => (
                                                                                <tr key={`${firm?.firm_id?._id}_${account.sub_category_id}_${account.account_id}`}>
                                                                                    <td>
                                                                                        <div className="__blkFx_bx">

                                                                                            <p>{account.account_name}</p>
                                                                                            <span className={`__spn${account.sub_category_name}`}>
                                                                                                {account.sub_category_name}
                                                                                            </span>
                                                                                        </div>

                                                                                    </td>
                                                                                    {["selection", "view", "create", "edit", "delete"].map((field) => (
                                                                                        <td key={field}>
                                                                                            <div className="__withOutlb">
                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    id={`${field}_${firm.firm_id?._id}_${account.sub_category_id}_${account.account_id}`}
                                                                                                    checked={!!account[field]}
                                                                                                    onChange={(e) =>
                                                                                                        handleAccountCheckboxForFirm(
                                                                                                            firm.firm_id?._id,
                                                                                                            account.sub_category_id,
                                                                                                            account.account_id,
                                                                                                            field,
                                                                                                            e.target.checked ? 1 : 0
                                                                                                        )
                                                                                                    }
                                                                                                    disabled={
                                                                                                        (field === "view" &&
                                                                                                            (account.create === 1 ||
                                                                                                                account.edit === 1 ||
                                                                                                                account.delete === 1)) ||
                                                                                                        disableFields
                                                                                                    }
                                                                                                />
                                                                                                <label
                                                                                                    htmlFor={`${field}_${firm.firm_id?._id}_${account.sub_category_id}_${account.account_id}`}
                                                                                                    className="anvLable"
                                                                                                >
                                                                                                    <span>{field}</span>
                                                                                                </label>
                                                                                            </div>
                                                                                        </td>
                                                                                    ))}
                                                                                    {/* Trip Approval */}
                                                                                    <td>
                                                                                        <CustomSelect
                                                                                            placeholder="Select"
                                                                                            options={mandatoryOptions}
                                                                                            value={
                                                                                                mandatoryOptions?.find(
                                                                                                    (i) => i?.value === account.trip_payment_approval
                                                                                                ) || { label: "Not Mandatory", value: 0 }
                                                                                            }
                                                                                            onSelect={(data) =>
                                                                                                handleApprovalChangeForFirm(
                                                                                                    firm.firm_id?._id,
                                                                                                    account.sub_category_id,
                                                                                                    account.account_id,
                                                                                                    "trip_payment_approval",
                                                                                                    data.value
                                                                                                )
                                                                                            }
                                                                                            disabled={account.create !== 1 || disableFields}
                                                                                        />
                                                                                    </td>
                                                                                    {/* Expenses Approval */}
                                                                                    <td>
                                                                                        <CustomSelect
                                                                                            placeholder="Select"
                                                                                            options={mandatoryOptions}
                                                                                            value={
                                                                                                mandatoryOptions?.find(
                                                                                                    (i) => i?.value === account.expenses_approval
                                                                                                ) || { label: "Not Mandatory", value: 0 }
                                                                                            }
                                                                                            onSelect={(data) =>
                                                                                                handleApprovalChangeForFirm(
                                                                                                    firm.firm_id?._id,
                                                                                                    account.sub_category_id,
                                                                                                    account.account_id,
                                                                                                    "expenses_approval",
                                                                                                    data.value
                                                                                                )
                                                                                            }
                                                                                            disabled={account.create !== 1 || disableFields}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    // OLD STRUCTURE: Direct branch and account list
                                    <div className="__adUsr_accordBx">
                                        <Checkbox
                                            type="checkbox"
                                            name="All Branch"
                                            className='__checkAllBox'
                                            id="selectAll"
                                            isDisabled={disableFields}
                                            handleClick={handleSelectAll}
                                            isChecked={branchList.every((branch) => branch.selection === 1)}
                                        />

                                        <div className="_addRl_checkList">
                                            <div className="_brxFlex">
                                                {branchList.map((branch, index) => (
                                                    <div className="_dLass" key={`${branch._id}_${index}`}>
                                                        <Checkbox
                                                            className="checkbox_2"
                                                            index={index}
                                                            type="checkbox"
                                                            name={branch?.branch}
                                                            isDisabled={disableFields}
                                                            id={branch._id}
                                                            handleClick={() => handleCheckboxChange(branch._id)}
                                                            isChecked={branch?.selection === 1}
                                                        />
                                                    </div>
                                                ))}
                                            </div>

                                            <div className="_mainRl_table __nWd_table">
                                                <div className="_addRl_headCheck">
                                                    <input
                                                        id="accountAccess"
                                                        type="checkbox"
                                                        onChange={handleAccountAccessToggle}
                                                        checked={isAllChecked}
                                                        disabled={disableFields}
                                                    />
                                                    <label htmlFor="accountAccess" className="anvLabel">
                                                        <p className="anvLabel">Account Access</p>
                                                    </label>
                                                </div>

                                                <table>
                                                    <thead>
                                                        <tr>
                                                            <th>Accounts</th>
                                                            <th>Full Access</th>
                                                            <th>View</th>
                                                            <th>Create</th>
                                                            <th>Edit</th>
                                                            <th>Delete</th>
                                                            <th>Trip Approval</th>
                                                            <th>Expenses Approval</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {modifyAccount.map((account) => (
                                                            <tr key={`_${account.sub_category_id}_${account.account_id}`}>
                                                                <td>
                                                                    <div className="__blkFx_bx">
                                                                        <p>{account.account_name}</p>
                                                                        <span className={`__spn${account.category_name}`}>
                                                                            {account.category_name}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                                {["selection", "view", "create", "edit", "delete"].map((field) => (
                                                                    <td key={field}>
                                                                        <div className="__withOutlb">
                                                                            <input
                                                                                type="checkbox"
                                                                                id={`${field}_${account.sub_category_id}_${account.account_id}`}
                                                                                checked={!!account[field]}
                                                                                onChange={(e) =>
                                                                                    handleCheckboxChangeForAccount(
                                                                                        account.sub_category_id,
                                                                                        account.account_id,
                                                                                        field,
                                                                                        e.target.checked ? 1 : 0
                                                                                    )
                                                                                }
                                                                                disabled={
                                                                                    (field === "view" &&
                                                                                        (account.create === 1 ||
                                                                                            account.edit === 1 ||
                                                                                            account.delete === 1)) ||
                                                                                    disableFields
                                                                                }
                                                                            />
                                                                            <label
                                                                                htmlFor={`${field}_${account.sub_category_id}_${account.account_id}`}
                                                                                className="anvLable"
                                                                            >
                                                                                <span>{field}</span>
                                                                            </label>
                                                                        </div>
                                                                    </td>
                                                                ))}
                                                                <td>
                                                                    <CustomSelect
                                                                        placeholder="Select"
                                                                        options={mandatoryOptions}
                                                                        value={
                                                                            mandatoryOptions?.find(
                                                                                (i) => i?.value === account.trip_payment_approval
                                                                            ) || { label: "Not Mandatory", value: 0 }
                                                                        }
                                                                        onSelect={(data) =>
                                                                            handleApprovalChange(
                                                                                account.sub_category_id,
                                                                                account.account_id,
                                                                                "trip_payment_approval",
                                                                                data.value
                                                                            )
                                                                        }
                                                                        disabled={account.create !== 1 || disableFields}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <CustomSelect
                                                                        placeholder="Select"
                                                                        options={mandatoryOptions}
                                                                        value={
                                                                            mandatoryOptions?.find(
                                                                                (i) => i?.value === account.expenses_approval
                                                                            ) || { label: "Not Mandatory", value: 0 }
                                                                        }
                                                                        onSelect={(data) =>
                                                                            handleApprovalChange(
                                                                                account.sub_category_id,
                                                                                account.account_id,
                                                                                "expenses_approval",
                                                                                data.value
                                                                            )
                                                                        }
                                                                        disabled={account.create !== 1 || disableFields}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {/* Transaction Permission Section */}
                            <div className="_addRl_bx">
                                <div className="_addRlHead">Transaction Permission</div>
                                <div className="_addRl_tableBx">
                                    <div className="___tpPern_fx">
                                        <p>Claim Approval</p>
                                        <div className="checkBx_lv">
                                            <input
                                                className="form-check-input _avPointer"
                                                id="0tpa_type1"
                                                type="radio"
                                                name="trip_payment_approval"
                                                value={1}
                                                checked={formValue?.trip_payment_approval === 1}
                                                autoComplete="off"
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, parseInt(value, 10))
                                                }
                                                disabled={disableFields}
                                            />
                                            <label htmlFor="0tpa_type1" className="form-check-label _avPointer">
                                                Required
                                            </label>
                                            &nbsp;
                                            <input
                                                className="form-check-input _avPointer"
                                                id="1tpa_type2"
                                                type="radio"
                                                name="trip_payment_approval"
                                                value={0}
                                                checked={formValue?.trip_payment_approval === 0}
                                                autoComplete="off"
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, parseInt(value, 10))
                                                }
                                                disabled={disableFields}
                                            />
                                            <label htmlFor="1tpa_type2" className="form-check-label _avPointer">
                                                Not Required
                                            </label>
                                            &nbsp;
                                        </div>
                                    </div>

                                    <div className="___tpPern_fx mt-3">
                                        <p>Expenses Approval</p>
                                        <div className="checkBx_lv">
                                            <input
                                                className="form-check-input _avPointer"
                                                id="0expenses_type1"
                                                type="radio"
                                                name="expenses_approval"
                                                value={1}
                                                checked={formValue?.expenses_approval === 1}
                                                autoComplete="off"
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, parseInt(value, 10))
                                                }
                                                disabled={disableFields}
                                            />
                                            <label htmlFor="0expenses_type1" className="form-check-label _avPointer">
                                                Required
                                            </label>
                                            &nbsp;
                                            <input
                                                className="form-check-input _avPointer"
                                                id="1expenses_type2"
                                                type="radio"
                                                name="expenses_approval"
                                                value={0}
                                                checked={formValue?.expenses_approval === 0}
                                                autoComplete="off"
                                                onChange={({ target: { name, value } }) =>
                                                    handleOnChange(name, parseInt(value, 10))
                                                }
                                                disabled={disableFields}
                                            />
                                            <label htmlFor="1expenses_type2" className="form-check-label _avPointer">
                                                Not Required
                                            </label>
                                            &nbsp;
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Submit Buttons */}
                    <div className="bottomFix">
                        {disableFields !== true && (
                            <button
                                className="_addComm_btn"
                                onClick={(e) => onSubmit(e, "add")}
                                type="button"
                                disabled={disabled || !isFormValid()}
                            >
                                {id ? "Update User" : "Add User"}
                            </button>
                        )}
                        {!id && (
                            <button
                                className="_addComm_btn"
                                onClick={(e) => onSubmit(e, "addSave")}
                                type="button"
                                disabled={disabled || !isFormValid()}
                            >
                                Add & New
                            </button>
                        )}
                        <button className="_cancel_btn" onClick={() => navigate(-1)}>
                            Cancel
                        </button>
                    </div>
                </>
            ) : (
                <div style={{ position: 'relative', flex: '1' }}>
                    <div className="loaderBg">
                        <Loading />
                    </div>
                </div>
            )}
        </div>
    );
};

export default AddUserFirm;

export const Checkbox = ({
    id,
    name,
    handleClick,
    isChecked,
    className,
    isDisabled,
}) => {
    return (
        <div className={className}>
            <input
                type="checkbox"
                id={id}
                onChange={handleClick}
                checked={isChecked}
                disabled={isDisabled}
            />
            <label htmlFor={id} className="anvLable" onClick={(e) => e.stopPropagation()} style={{ display: "inline-block", width: " fit - content", whiteSpace: "nowrap" }}>
                {name}
            </label>
        </div>
    );
};
